import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { getDefaultCountry, getDefaultCurrency, getDefaultLanguage, getDefaultLanguages, getDefaultLocale, getDefaultLocales, getDefaultTimeZone } from "../config";
export var getG11nStateCreator = function () {
  var initialState = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return function (set) {
    return _objectSpread(_objectSpread({
      language: getDefaultLanguage(),
      locale: getDefaultLocale(),
      country: getDefaultCountry(),
      currency: getDefaultCurrency(),
      timeZone: getDefaultTimeZone(),
      languages: getDefaultLanguages(),
      locales: getDefaultLocales()
    }, initialState), {}, {
      setLanguage: function (language) {
        return set({
          language: language
        });
      },
      setLocale: function (locale) {
        return set({
          locale: locale
        });
      },
      setCountry: function (country) {
        return set({
          country: country
        });
      },
      setCurrency: function (currency) {
        return set({
          currency: currency
        });
      },
      setTimeZone: function (timeZone) {
        return set({
          timeZone: timeZone
        });
      },
      setLanguages: function (languages) {
        return set({
          languages: languages
        });
      },
      setLocales: function (locales) {
        return set({
          locales: locales
        });
      }
    });
  };
};